export default __webpack_public_path__ + "static/media/2fa_forgot_password.0142ce10.png";